export const ERROR_QR_CODE = "https://media-assets.swiggy.com/portal/static-assets/images/dinecash/QR_error.png";
export const QR_IMAGE_SIZE = "164px";
